import React, { useState, useEffect, useCallback } from 'react';
import { ChevronRight, ChevronLeft, MapPin, Users, Plane, Car, User, CreditCard, Check, AlertCircle, Loader2, Hotel, Globe, X, Search, Info } from 'lucide-react';
import axios from 'axios';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import headerImg from '../../assets/img/header.png'
import FlywirePayment from '../FlywirePayment/FlywirePayment';

import './TripBookingForm.css'
import '../FlywirePayment/FlywirePayment.css'

// const API_BASE_URL = 'http://localhost:5003/api';
// const API_BASE_URL = 'https://ctsdmc-backend.onrender.com/api';
const API_BASE_URL = 'https://api.ctsdmcwpc.com/api';

const TripBookingForm = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({
    adults: 0,
    children: 0,
    destination: '',
    destinationAirportCode: '', // Store the airport code from destination
    hotel: '',
    selectedZone: '', 
    airport: '',
    flightType: 'round',
    departureDate: '',
    departureAirline: '',
    departureFlightNumber: '',
    departureManualFlight: '',
    arrivalDate: '',
    arrivalAirline: '',
    arrivalFlightNumber: '',
    arrivalManualFlight: '',
    oneWayType: 'departure',
    oneWayDate: '',
    oneWayAirline: '',
    oneWayFlightNumber: '',
    oneWayManualFlight: '',
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    zipCode: '',
    total: 0
  });
  const [hasSetPassengers, setHasSetPassengers] = useState(false);
  const [activeVehicleTab, setActiveVehicleTab] = useState("arrival");
  const [selectedVehicles, setSelectedVehicles] = useState({
    arrival: null,
    departure: null,
    oneWay: null
  });

  const [apiData, setApiData] = useState({
    destinations: [],
    airlines: [],
    vehicles: [],
    hotels: [],
    airports: [],
    zones: [],
    allVehicles: [],
    filteredVehicles: []
  });

  const [isLoading, setIsLoading] = useState({
    destinations: true,
    airlines: false,
    vehicles: false,
    hotels: false,
    airports: false,
    form: false
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showFlywirePayment, setShowFlywirePayment] = useState(false);
  const [flywireSessionId, setFlywireSessionId] = useState('');

  const formatDateMMDDYYYY = (date) => {
    if (!date) return "";
    return date
      .toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
      })
      .replace(/\//g, "");
  };

  // Function to get vehicle image URL
  // const getVehicleImageUrl = (vehicle) => {
  //   if (vehicle.Image) {
      
  //     let imageUrl = vehicle.Image;
  //     if (imageUrl.includes('filepath=')) {
  //       const filepathMatch = imageUrl.match(/filepath=([^&]+)/);
  //       if (filepathMatch) {
  //         const filepath = filepathMatch[1];
  //         // Use your backend to serve the image
  //         return `${API_BASE_URL}/vehicle-image/${vehicle.ID}/${filepath}`;
  //       }
  //     }
      
  //     // If it's already a complete URL from your backend, use it as is
  //     if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
  //       return imageUrl;
  //     }
      
  //     // If it's a relative path, construct with your API base
  //     if (imageUrl.startsWith('/')) {
  //       return `${API_BASE_URL}${imageUrl}`;
  //     }
      
  //     // Fallback: try to use it directly with your API base
  //     return `${API_BASE_URL}/vehicle-image/${vehicle.ID}`;
  //   }
    
  //   // Return null if no image is available
  //   return null;
  // };

  // Fixed function to handle the actual Image_URL object structure
const getVehicleImageUrl = (vehicle) => {
  if (vehicle.Image_URL) {
    let imageUrl = vehicle.Image_URL;
    
    // If Image_URL is an object, extract the URL from value or url property
    if (typeof imageUrl === 'object') {
      imageUrl = imageUrl.value || imageUrl.url || '';
    }
    
    // If we have a valid URL string, return it
    if (typeof imageUrl === 'string' && imageUrl.trim() !== '') {
      return imageUrl;
    }
  }
  return '';
};

  const flightOptions = flightsList => {
    // Add safety check to ensure flightsList is an array
    if (!Array.isArray(flightsList)) {
      return [];
    }
    
    return flightsList.map(f => ({
      value: f.id,
      label: `${f.flightCode} (${f.origin} → ${f.destination}) ${f.departureTime} - ${f.arrivalTime}`,
    }));
  };

  const [flights, setFlights] = useState({
    departure: [],
    arrival: [],
    oneWay: []
  });
  const [loadingFlights, setLoadingFlights] = useState(false);

  // Updated loadFlights function to include airport code
  const loadFlights = useCallback(async (airlineId, type, date, targetKey) => {
    if (!airlineId || !type || !date || !formData.destinationAirportCode) return;

    // Find the airline name from the airlines array
    const selectedAirline = apiData.airlines.find(airline => airline.ID === airlineId);
    if (!selectedAirline) return;

    setLoadingFlights(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/flights`, {
        params: { 
          airline: selectedAirline.Airline, // Send airline name instead of ID
          type, 
          date,
          airport: formData.destinationAirportCode // Include airport code from destination
        }
      });
      setFlights(prev => ({ ...prev, [targetKey]: response.data }));
      
      // Clear any previous flight-related errors when flights load successfully
      setError('');
    } catch (err) {
      console.error("Error loading flights:", err);

      if (err.response && err.response.status === 404) {
        setError("No flights available for the region.");
      } else {
        setError("Error. Please refresh the page and try again.");
      }
    } finally {
      setLoadingFlights(false);
    }
  }, [apiData.airlines, formData.destinationAirportCode]); // Add destinationAirportCode as dependency

  // Update the useEffect hooks to include airport code dependency
  useEffect(() => {
    if (formData.departureAirline && formData.departureDate && apiData.airlines.length > 0 && formData.destinationAirportCode) {
      loadFlights(formData.departureAirline, "departure", formatDateMMDDYYYY(formData.departureDate), "departure");
    }
  }, [formData.departureAirline, formData.departureDate, loadFlights, apiData.airlines.length, formData.destinationAirportCode]);

  useEffect(() => {
    if (formData.arrivalAirline && formData.arrivalDate && apiData.airlines.length > 0 && formData.destinationAirportCode) {
      loadFlights(formData.arrivalAirline, "arrival", formatDateMMDDYYYY(formData.arrivalDate), "arrival");
    }
  }, [formData.arrivalAirline, formData.arrivalDate, loadFlights, apiData.airlines.length, formData.destinationAirportCode]);

  useEffect(() => {
    if (formData.oneWayAirline && formData.oneWayDate && apiData.airlines.length > 0 && formData.destinationAirportCode) {
      loadFlights(formData.oneWayAirline, formData.oneWayType, formatDateMMDDYYYY(formData.oneWayDate), "oneWay");
    }
  }, [formData.oneWayAirline, formData.oneWayDate, formData.oneWayType, loadFlights, apiData.airlines.length, formData.destinationAirportCode]);

  const toOptions = (items, labelKey, valueKey = "ID") => 
    items
      .map(item => ({
        value: item[valueKey],
        label: item[labelKey],
      }))
      .sort((a, b) => a.label.localeCompare(b.label));

  const fetchData = useCallback(async (endpoint, dataKey = null) => {
    try {
      if (dataKey) {
        setIsLoading(prev => ({ ...prev, [dataKey]: true }));
      }
      const response = await axios.get(`${API_BASE_URL}${endpoint}`);
      if (response.data && response.data.data) {
        return response.data.data;
      }
      return [];
    } catch (err) {
      console.error("Error loading data:", err);

      if (err.response && err.response.status === 404) {
        setError("No Data available for the region.");
      } else {
        setError("Error. Please refresh the page and try again.");
      }
    } finally {
      if (dataKey) {
        setIsLoading(prev => ({ ...prev, [dataKey]: false }));
      }
    }
  }, []);

  const initializeForm = useCallback(async () => {
    setError('');
    try {
      const destinationsData = await fetchData('/destinations', 'destinations');
      setApiData(prev => ({
        ...prev,
        destinations: destinationsData
      }));
    } catch (error) {
      console.error('Error initializing form:', error);
      setError('Failed to load form data. Please refresh the page.');
    }
  }, [fetchData]);

  const loadVehiclesData = useCallback(async () => {
    try {
      setIsLoading(prev => ({ ...prev, vehicles: true }));
      const vehiclesData = await fetchData('/vehicles');
      setApiData(prev => ({
        ...prev,
        allVehicles: vehiclesData,
        vehicles: vehiclesData
      }));
    } catch (err) {
      console.error("Error loading vehicles:", err);

      if (err.response && err.response.status === 404) {
        setError("No Vehicles available for the region.");
      } else {
        setError("Error. Please refresh the page and try again.");
      }
    } finally {
      setIsLoading(prev => ({ ...prev, vehicles: false }));
    }
  }, [fetchData]);

  const loadAirlinesData = useCallback(async () => {
    if (apiData.airlines.length === 0 && !isLoading.airlines) {
      const airlinesData = await fetchData('/airlines', 'airlines');
      setApiData(prev => ({ ...prev, airlines: airlinesData }));
    }
  }, [apiData.airlines.length, isLoading.airlines, fetchData]);

  useEffect(() => {
    const loadDestinationData = async () => {
      if (!formData.destination) return;
      try {
        const [hotelsData, airportsData] = await Promise.all([
          fetchData(`/hotels/${formData.destination}`, 'hotels'),
          fetchData(`/airports/${formData.destination}`, 'airports')
        ]);
        
        // Extract unique zones from hotels data
        const uniqueZones = [...new Set(
          hotelsData
            .filter(hotel => hotel.Zona?.display_value) // Only hotels with zone data
            .map(hotel => hotel.Zona.display_value)
        )].sort();
        
        setApiData(prev => ({
          ...prev,
          hotels: hotelsData,
          airports: airportsData,
          zones: uniqueZones
        }));
      } catch (error) {
        console.error('Error loading destination data:', error);
        setError('Failed to load destination details.');
      }
    };
    loadDestinationData();
  }, [formData.destination, fetchData]);

  useEffect(() => {
    if (apiData.allVehicles.length === 0) return;
    
    const adults = parseInt(formData.adults) || 0;
    const children = parseInt(formData.children) || 0;
    const total = adults + children;
    
    const filtered = apiData.allVehicles.filter(vehicle => {
      const minCap = parseInt(vehicle.Minimum_Capacity) || 0;
      const maxCap = parseInt(vehicle.Maximum_Capacity) || 9999;
      const matchesCapacity = total >= minCap && total <= maxCap;
      const matchesAirport = !formData.airport || vehicle.Airport?.ID === formData.airport;
      
      // Case-insensitive zone comparison with trimming
      const matchesZone = !formData.selectedZone || 
        vehicle.Zone?.toLowerCase().trim() === formData.selectedZone?.toLowerCase().trim();
      
      return matchesCapacity && matchesAirport && matchesZone;
    });
    
    setApiData(prev => ({
      ...prev,
      filteredVehicles: filtered
    }));
  }, [
    formData.adults,
    formData.children,
    formData.flightType,
    formData.oneWayType,
    formData.airport,
    formData.selectedZone,
    apiData.allVehicles
  ]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    // Clear error when user makes changes
    const flightRelatedFields = [
      'arrivalAirline', 'departureAirline', 'oneWayAirline', 
      'arrivalFlightNumber', 'departureFlightNumber', 'oneWayFlightNumber'
    ];
    
    if (!flightRelatedFields.includes(name)) {
      setError('');
    }

    if (name === "adults" || name === "children") {
      setHasSetPassengers(true);
    }
    
    // Handle destination selection
    if (name === "destination") {
      const selectedDestination = apiData.destinations.find(dest => dest.ID === value);
      const airportCode = selectedDestination?.Airport?.display_value || '';
      
      setFormData(prevState => ({
        ...prevState,
        destination: value,
        destinationAirportCode: airportCode,
        hotel: '', // Reset hotel when destination changes
        selectedZone: '', // Reset zone when destination changes
        // Reset flight related fields when destination changes
        arrivalAirline: '',
        departureAirline: '',
        oneWayAirline: '',
        arrivalFlightNumber: '',
        departureFlightNumber: '',
        oneWayFlightNumber: '',
        arrivalManualFlight: '',
        departureManualFlight: '',
        oneWayManualFlight: ''
      }));
      
      // Clear flights when destination changes
      setFlights({
        departure: [],
        arrival: [],
        oneWay: []
      });
      
      return;
    }
    
    // Handle hotel selection - extract zone information
    if (name === "hotel") {
      const selectedHotel = apiData.hotels.find(hotel => hotel.ID === value);
      const selectedZone = selectedHotel?.Zona?.display_value || '';
      
      setFormData(prevState => ({
        ...prevState,
        hotel: value,
        selectedZone: selectedZone
      }));
      
      return;
    }
    
    setFormData(prevState => ({
      ...prevState,
      [name]: type === 'radio' ? (checked ? value : prevState[name]) : value
    }));
  };

  const handleVehicleSelect = (vehicle, serviceType) => {
    setError(''); // Clear errors when vehicle is selected
    const key = formData.flightType === 'one-way' ? 'oneWay' : serviceType;
    setSelectedVehicles(prev => ({
      ...prev,
      [key]: vehicle,
    }));
  };

  useEffect(() => {
    let total = 0;
    if (formData.flightType === "round") {
      const arrivalPrice = selectedVehicles.arrival?.Price_Per_Vehicle || 0;
      const departurePrice = selectedVehicles.departure?.Price_Per_Vehicle || 0;
      total = Number(arrivalPrice) + Number(departurePrice);
    } else {
      total = Number(selectedVehicles.oneWay?.Price_Per_Vehicle) || 0;
    }
    setFormData(prev => ({
      ...prev,
      total,
    }));
  }, [formData.flightType, selectedVehicles]);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && currentStep !== 5) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  useEffect(() => {
    initializeForm();
    loadVehiclesData();
  }, [initializeForm, loadVehiclesData]);

  useEffect(() => {
    if (formData.destination) {
      loadAirlinesData();
    }
  }, [formData.destination, loadAirlinesData]);

  const steps = [
    { 
      id: 1, 
      title: "Trip Details", 
      icon: MapPin,
      description: "Tell us about your trip"
    },
    { 
      id: 2, 
      title: "Flight Info", 
      icon: Plane,
      description: "Flight details and dates"
    },
    { 
      id: 3, 
      title: "Vehicle Selection", 
      icon: Car,
      description: "Choose your transport"
    },
    { 
      id: 4, 
      title: "Passenger Info", 
      icon: User,
      description: "Lead passenger details"
    },
    { 
      id: 5, 
      title: "Review & Pay", 
      icon: CreditCard,
      description: "Confirm and complete"
    }
  ];

  const validateStep = () => {
    switch (currentStep) {
      case 1:
        if (
          !formData.adults ||
          formData.adults < 1 ||
          !formData.destination ||
          !formData.hotel ||
          !formData.airport
        ) {
          setError('Please complete all required fields in Trip Details.');
          return false;
        }
        break;

      case 2:
        if (formData.flightType === 'round') {
          if (
            !formData.arrivalDate ||
            !formData.arrivalAirline ||
            !formData.departureDate ||
            !formData.departureAirline
          ) {
            setError('Please complete all required fields in Flight Information.');
            return false;
          }
          
          // Check if either flight number or manual flight is provided for arrival
          if (!formData.arrivalFlightNumber && !formData.arrivalManualFlight) {
            setError('Please select a flight or enter a flight code for arrival.');
            return false;
          }
          
          // Check if either flight number or manual flight is provided for departure
          if (!formData.departureFlightNumber && !formData.departureManualFlight) {
            setError('Please select a flight or enter a flight code for departure.');
            return false;
          }
        } else if (formData.flightType === 'one-way') {
          if (
            !formData.oneWayDate ||
            !formData.oneWayAirline
          ) {
            setError('Please complete all required fields in Flight Information.');
            return false;
          }
          
          // Check if either flight number or manual flight is provided for one-way
          if (!formData.oneWayFlightNumber && !formData.oneWayManualFlight) {
            setError('Please select a flight or enter a flight code for your one-way trip.');
            return false;
          }
        }
        break;

      case 3:
        if (formData.flightType === 'round') {
          if (!selectedVehicles.arrival || !selectedVehicles.departure) {
            setError('Please select vehicles for both arrival and departure.');
            return false;
          }
        } else {
          if (!selectedVehicles.oneWay) {
            setError('Please select a vehicle for your one-way trip.');
            return false;
          }
        }
        break;

      case 4:
        const nameRegex = /^[A-Za-z\s'-]+$/;
        const numberRegex = /^\d+$/;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (
          !formData.firstName.trim() ||
          !nameRegex.test(formData.firstName.trim()) ||
          !formData.lastName.trim() ||
          !nameRegex.test(formData.lastName.trim()) ||
          !formData.phone.trim() ||
          !numberRegex.test(formData.phone.trim()) ||
          !formData.email.trim() ||
          !emailRegex.test(formData.email.trim()) ||
          (formData.zipCode && !numberRegex.test(formData.zipCode.trim()))
        ) {
          setError('Please enter valid information: names with letters only, phone and zip with numbers only, and a valid email.');
          return false;
        }
        break;

      default:
        break;
    }
    setError('');
    return true;
  };

  const nextStep = () => {
    if (validateStep()) {
      if (currentStep < 5) {
        setCurrentStep(currentStep + 1);
      }
    }
  };

  const handleSubmit = async () => {
    if (currentStep !== 5) {
      return;
    }

    if (!validateStep()) return;

    setIsSubmitting(true);
    setError('');
    setSuccess('');

    try {
      const payload = {
        ...formData,
        arrivalDate: formData.arrivalDate ? formatDateMMDDYYYY(formData.arrivalDate) : '',
        departureDate: formData.departureDate ? formatDateMMDDYYYY(formData.departureDate) : '',
        oneWayDate: formData.oneWayDate ? formatDateMMDDYYYY(formData.oneWayDate) : '',
        vehicleArrival: selectedVehicles.arrival?.ID || null,
        vehicleDeparture: selectedVehicles.departure?.ID || null,
        vehicleOneWay: selectedVehicles.oneWay?.ID || null,
        // These airline fields will contain the airline IDs as needed
        arrivalAirline: formData.arrivalAirline, // This is already the airline ID
        departureAirline: formData.departureAirline, // This is already the airline ID  
        oneWayAirline: formData.oneWayAirline, // This is already the airline ID
        // Include the airport code in the payload
        destinationAirportCode: formData.destinationAirportCode
      };

      const response = await axios.post(`${API_BASE_URL}/submit-order`, payload);

      if (response.data && response.data.session_id) {
        setFlywireSessionId(response.data.session_id);
        setShowFlywirePayment(true);
      } else {
        setError(response.data.message || 'Failed to submit form');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setError('Failed to submit form. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleFlywireSuccess = (sessionResult) => {
    // Note: The sessionResult has already been sent to backend by FlywirePayment component
    // This is just for UI feedback
    setSuccess('Payment was created successfully! You will receive a confirmation email shortly.');
    setShowFlywirePayment(false);
    
    console.log('Payment success - sessionResult received:', sessionResult);
    
    // Show success message and redirect after delay
    setTimeout(() => {
      window.location.href = '/booking-confirmation';
    }, 3000);
  };

  const handleFlywireError = (error) => {
    // Note: Error details have already been sent to backend by FlywirePayment component
    // This is just for UI feedback
    setError(`Payment failed: ${error.message || 'Something went wrong. Please try again.'}`);
    setShowFlywirePayment(false);
    console.error('Payment error:', error);
  };

  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const ProgressBar = () => (
    <div className="progress-container">
      <div className="progress-bar">
        <div 
          className="progress-fill"
          style={{ width: `${(currentStep / 5) * 100}%` }}
        />
      </div>
      <div className="steps-container">
        {steps.map((step) => {
          const Icon = step.icon;
          return (
            <div 
              key={step.id}
              className={`step-item ${currentStep >= step.id ? 'active' : ''} ${currentStep === step.id ? 'current' : ''}`}
            >
              <div className="step-circle">
                {currentStep > step.id ? (
                  <Check className="w-4 h-4" />
                ) : (
                  <Icon className="w-4 h-4" />
                )}
              </div>
              <div className="step-content">
                <div className="step-title">{step.title}</div>
                <div className="step-description">{step.description}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );

  const CustomSelectWithSearch = ({ options, value, onChange, placeholder, isLoading, disabled, name }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const selectedOption = options.find(opt => opt.value === value);

    const filteredOptions = options.filter(option =>
      option.label.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
      <div className="custom-select">
        <div 
          className={`select-trigger ${disabled ? 'disabled' : ''} ${isOpen ? 'open' : ''}`}
          onClick={() => !disabled && setIsOpen(!isOpen)}
        >
          <span className={selectedOption ? 'selected' : 'placeholder'}>
            {isLoading ? (
              <span className="loading-text">
                <Loader2 className="w-4 h-4 animate-spin" />
                Loading...
              </span>
            ) : (
              selectedOption ? selectedOption.label : placeholder
            )}
          </span>
          <ChevronRight className={`chevron ${isOpen ? 'rotated' : ''}`} />
        </div>
        {isOpen && !disabled && (
          <div className="select-dropdown">
            <div className="select-search">
              <Search className="search-icon" />
              <input
                type="text"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-input"
              />
            </div>
            <div className="select-options-list">
              {filteredOptions.length > 0 ? (
                filteredOptions.map((option) => (
                  <div
                    key={option.value}
                    className={`select-option ${value === option.value ? 'selected' : ''}`}
                    onClick={() => {
                      onChange({ target: { name, value: option.value } });
                      setIsOpen(false);
                      setSearchTerm("");
                    }}
                  >
                    {option.label}
                  </div>
                ))
              ) : (
                <div className="select-option no-results">
                  No results found
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  };

  const NotificationToast = ({ message, type, onClose }) => (
    <div className={`toast toast-${type}`}>
      <div className="toast-content">
        {type === 'error' ? (
          <AlertCircle className="toast-icon" />
        ) : (
          <Check className="toast-icon" />
        )}
        <span>{message}</span>
      </div>
      <button onClick={onClose} className="toast-close">
        <X className="w-4 h-4" />
      </button>
    </div>
  );

  const renderStepContent = () => {
    switch (currentStep) {
      case 1:
        return (
          <div className="step-content-wrapper">
            <div className="step-header">
              <MapPin className="step-icon" />
              <div>
                <h2>Trip Details</h2>
                <p>Tell us about your travel plans</p>
              </div>
            </div>
            
            <div className="form-grid">
              <div className="form-group">
                <label className="form-label">
                  <Users className="label-icon" />
                  Adults *
                </label>
                <input
                  type="number"
                  name="adults"
                  className="form-input"
                  placeholder="1"
                  min="1"
                  value={formData.adults}
                  onChange={handleInputChange}
                  required
                />
              </div>
              
              <div className="form-group">
                <label className="form-label">
                  <Users className="label-icon" />
                  Children
                </label>
                <input
                  type="number"
                  name="children"
                  className="form-input"
                  placeholder="0"
                  min="0"
                  value={formData.children}
                  onChange={handleInputChange}
                />
              </div>
              
              <div className="form-group">
                <label className="form-label">
                  <Globe className="label-icon" />
                  Destination *
                </label>
                <CustomSelectWithSearch
                  name="destination"
                  options={toOptions(apiData.destinations, "Destination")}
                  value={formData.destination}
                  onChange={handleInputChange}
                  placeholder="Select destination..."
                  isLoading={isLoading.destinations}
                />
                {/* Debug info - remove in production */}
                {formData.destinationAirportCode && (
                  <div className="text-sm text-gray-500 mt-1">
                    Airport Code: {formData.destinationAirportCode}
                  </div>
                )}
              </div>
              
              <div className="form-group">
                <label className="form-label">
                  <Hotel className="label-icon" />
                  Hotel *
                </label>
                <CustomSelectWithSearch
                  name="hotel"
                  options={toOptions(apiData.hotels, "Hotel")}
                  value={formData.hotel}
                  onChange={handleInputChange}
                  placeholder="Select hotel..."
                  isLoading={isLoading.hotels}
                  disabled={!formData.destination}
                />
                {/* Show selected zone for confirmation */}
                {formData.selectedZone && (
                  <div className="text-sm text-gray-600 mt-1">
                    Zone: {formData.selectedZone}
                  </div>
                )}
              </div>
              
              <div className="form-group full-width">
                <label className="form-label">
                  <Plane className="label-icon" />
                  Airport *
                </label>
                <CustomSelectWithSearch
                  name="airport"
                  options={toOptions(apiData.airports, "Airport")}
                  value={formData.airport}
                  onChange={handleInputChange}
                  placeholder="Select airport..."
                  isLoading={isLoading.airports}
                  disabled={!formData.destination}
                />
              </div>
            </div>
          </div>
        );

      case 2:
        return (
          <div className="step-content-wrapper">
            <div className="step-header">
              <Plane className="step-icon" />
              <div>
                <h2>Flight Information</h2>
                <p>Choose your flight type and details</p>
              </div>
            </div>

            <div className="flight-type-selector">
              <label className="radio-card">
                <input
                  type="radio"
                  name="flightType"
                  value="round"
                  checked={formData.flightType === 'round'}
                  onChange={handleInputChange}
                />
                <div className="radio-card-content">
                  <div className="radio-check"></div>
                  <div>
                    <h3>Round Trip</h3>
                    <p>Departure and arrival flights</p>
                  </div>
                </div>
              </label>
              
              <label className="radio-card">
                <input
                  type="radio"
                  name="flightType"
                  value="one-way"
                  checked={formData.flightType === 'one-way'}
                  onChange={handleInputChange}
                />
                <div className="radio-card-content">
                  <div className="radio-check"></div>
                  <div>
                    <h3>One Way</h3>
                    <p>Single flight booking</p>
                  </div>
                </div>
              </label>
            </div>

            {formData.flightType === 'round' && (
              <div className="flight-details-container">
                <div className="flight-section">
                  <h3 className="flight-section-title">
                    <Plane className="w-5 h-5" style={{ transform: 'rotate(-45deg)' }} />
                    Arrival Flight
                  </h3>
                  <div className="form-grid">
                    <div className="form-group">
                      <label className="form-label">Date *</label>
                      <DatePicker
                        selected={formData.arrivalDate}
                        onChange={(date) => {
                          setError(''); // Clear errors when date changes
                          setFormData((prev) => ({
                            ...prev,
                            arrivalDate: date,
                            arrivalDateFormatted: formatDateMMDDYYYY(date),
                          }));
                        }}
                        dateFormat="MM/dd/yyyy"
                        placeholderText="MM/DD/YYYY"
                        name="arrivalDate"
                        className="form-input date-picker"
                      />
                    </div>
                    
                    <div className="form-group">
                      <label className="form-label">Airline *</label>
                      <CustomSelectWithSearch 
                        name="arrivalAirline"
                        options={toOptions(apiData.airlines, "Airline", "ID")}
                        value={formData.arrivalAirline}
                        onChange={handleInputChange}
                        placeholder="Select airline..."
                        isLoading={isLoading.airlines}
                      />
                    </div>

                    <div className="form-group">
                      <label className="form-label">Flight</label>
                      <div className="flight-input-container">
                        <CustomSelectWithSearch
                          name="arrivalFlightNumber"
                          options={flightOptions(flights.arrival)}
                          value={formData.arrivalFlightNumber}
                          onChange={handleInputChange}
                          placeholder="Select flight..."
                          isLoading={loadingFlights}
                          disabled={!formData.arrivalAirline || !formData.arrivalDate}
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label className="form-label"> </label>
                        <div className="helper-note">
                        <Info className="helper-icon" />
                        If you can't find your flight please add the flight code here
                        </div>

                        <input
                          type="text"
                          name="arrivalManualFlight"
                          className="form-input"
                          placeholder="Enter flight code"
                          value={formData.arrivalManualFlight}
                          onChange={handleInputChange}
                        />
                    </div>
                  </div>
                </div>

                <div className="flight-section">
                  <h3 className="flight-section-title">
                    <Plane className="w-5 h-5" style={{ transform: 'rotate(135deg)' }} />
                    Departure Flight
                  </h3>
                  <div className="form-grid">
                    <div className="form-group">
                      <label className="form-label">Date *</label>
                      <DatePicker
                        selected={formData.departureDate}
                        onChange={(date) => {
                          setError(''); // Clear errors when date changes
                          setFormData((prev) => ({
                            ...prev,
                            departureDate: date,
                            departureDateFormatted: formatDateMMDDYYYY(date),
                          }));
                        }}
                        dateFormat="MM/dd/yyyy"
                        placeholderText="MM/DD/YYYY"
                        name="departureDate"
                        className="form-input date-picker"
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Airline *</label>
                      <CustomSelectWithSearch 
                        name="departureAirline"
                        options={toOptions(apiData.airlines, "Airline", "ID")}
                        value={formData.departureAirline}
                        onChange={handleInputChange}
                        placeholder="Select airline..."
                        isLoading={isLoading.airlines}
                      />
                    </div>

                    <div className="form-group">
                      <label className="form-label">Flight</label>
                      <div className="flight-input-container">
                        <CustomSelectWithSearch
                          name="departureFlightNumber"
                          options={flightOptions(flights.departure)}
                          value={formData.departureFlightNumber}
                          onChange={handleInputChange}
                          placeholder="Select flight..."
                          isLoading={loadingFlights}
                          disabled={!formData.departureAirline || !formData.departureDate}
                        />
                      </div>
                    </div>

                     <div className="form-group">
                      <div className="helper-note">
                        <Info className="helper-icon" />
                        If you can't find your flight please add the flight code here
                      </div>
                        <input
                          type="text"
                          name="departureManualFlight"
                          className="form-input"
                          placeholder="Enter flight code"
                          value={formData.departureManualFlight}
                          onChange={handleInputChange}
                        />
                    </div>
                  </div>
                </div>
              </div>
            )}

            {formData.flightType === 'one-way' && (
              <>
                <div className="flight-type-selector">
                  <label className="radio-card small">
                    <input
                      type="radio"
                      name="oneWayType"
                      value="arrival"
                      checked={formData.oneWayType === 'arrival'}
                      onChange={handleInputChange}
                    />
                    <div className="radio-card-content">
                      <div className="radio-check"></div>
                      <span>Arrival</span>
                    </div>
                  </label>
                </div>
                 <div className="flight-type-selector">
                  <label className="radio-card small">
                    <input
                      type="radio"
                      name="oneWayType"
                      value="departure"
                      checked={formData.oneWayType === 'departure'}
                      onChange={handleInputChange}
                    />
                    <div className="radio-card-content">
                      <div className="radio-check"></div>
                      <span>Departure</span>
                    </div>
                  </label>
                </div>

                <div className="flight-section">
                  <h3 className="flight-section-title">
                    <Plane className="w-5 h-5" style={{ 
                      transform: formData.oneWayType === 'departure' ? 'rotate(135deg)' : 'rotate(-45deg)' 
                    }} />
                    {formData.oneWayType === 'departure' ? 'Departure' : 'Arrival'} Flight
                  </h3>
                  <div className="form-grid">
                    <div className="form-group">
                      <label className="form-label">Date *</label>
                      <DatePicker
                        selected={formData.oneWayDate}
                        onChange={(date) => {
                          setError(''); // Clear errors when date changes
                          setFormData((prev) => ({
                            ...prev,
                            oneWayDate: date,
                            oneWayDateFormatted: formatDateMMDDYYYY(date),
                          }));
                        }}
                        dateFormat="MM/dd/yyyy"
                        placeholderText="MM/DD/YYYY"
                        name="oneWayDate"
                        className="form-input date-picker"
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Airline *</label>
                      <CustomSelectWithSearch 
                        name="oneWayAirline"
                        options={toOptions(apiData.airlines, "Airline", "ID")}
                        value={formData.oneWayAirline}
                        onChange={handleInputChange}
                        placeholder="Select airline..."
                        isLoading={isLoading.airlines}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Flight</label>
                      <div className="flight-input-container">
                        <CustomSelectWithSearch
                          name="oneWayFlightNumber"
                          options={flightOptions(flights.oneWay)}
                          value={formData.oneWayFlightNumber}
                          onChange={handleInputChange}
                          placeholder="Select flight..."
                          isLoading={loadingFlights}
                          disabled={!formData.oneWayAirline || !formData.oneWayDate}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <div className="helper-note">
                        <Info className="helper-icon" />
                        If you can't find your flight please add the flight code here
                      </div>
                        <input
                          type="text"
                          name="oneWayManualFlight"
                          className="form-input"
                          placeholder="Enter flight code"
                          value={formData.oneWayManualFlight}
                          onChange={handleInputChange}
                        />
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        );

      case 3:
        if (!hasSetPassengers) {
          return (
            <div className="step-content-wrapper">
              <div className="empty-state">
                <Car className="empty-icon" />
                <h3>Set Passenger Count First</h3>
                <p>Please go back and set the number of adults and children to see vehicle options.</p>
              </div>
            </div>
          );
        }

        return (
          <div className="step-content-wrapper">
            <div className="step-header">
              <Car className="step-icon" />
              <div>
                <h2>Vehicle Selection</h2>
                <p>Choose your preferred transportation</p>
              </div>
            </div>

            {formData.flightType === "round" ? (
              <>
                <div className="vehicle-tabs">
                  <button
                    type="button"
                    className={`tab-btn ${activeVehicleTab === "arrival" ? "active" : ""}`}
                    onClick={() => setActiveVehicleTab("arrival")}
                  >
                    <Plane className="w-4 h-4" style={{ transform: 'rotate(-45deg)' }} />
                    Arrival Vehicles
                  </button>
                  <button
                    type="button"
                    className={`tab-btn ${activeVehicleTab === "departure" ? "active" : ""}`}
                    onClick={() => setActiveVehicleTab("departure")}
                  >
                    <Plane className="w-4 h-4" style={{ transform: 'rotate(135deg)' }} />
                    Departure Vehicles
                  </button>
                </div>

                <div className="vehicles-grid">
                  {activeVehicleTab === "arrival" && 
                    apiData.filteredVehicles
                      .filter(v => v.Type_of_Service?.toLowerCase().includes("arrival"))
                      .map(vehicle => (
                        <div
                          key={vehicle.ID}
                          className={`vehicle-card ${selectedVehicles.arrival?.ID === vehicle.ID ? "selected" : ""}`}
                          onClick={() => handleVehicleSelect(vehicle, "arrival")}
                        >
                          <div className="vehicle-image">
                            {getVehicleImageUrl(vehicle) ? (
                              <img
                                src={getVehicleImageUrl(vehicle)}
                                alt={vehicle.Type_of_Vehicle}
                                onError={(e) => {
                                  // Hide image if it fails to load
                                  e.target.style.display = 'none';
                                }}
                              />
                            ) : (
                              <div className="no-image-placeholder">
                                <Car className="w-12 h-12 text-gray-400" />
                                <span className="text-sm text-gray-500">No Image</span>
                              </div>
                            )}
                          </div>
                          <div className="vehicle-info">
                            <h4>{vehicle.Type_of_Vehicle}</h4>
                            <div className="vehicle-price">${vehicle.Price_Per_Vehicle}</div>
                            <div className="vehicle-capacity">
                              <Users className="w-4 h-4" />
                              {vehicle.Minimum_Capacity} - {vehicle.Maximum_Capacity} passengers
                            </div>
                            <div className="vehicle-service">{vehicle.Type_of_Service}</div>
                          </div>
                          <div className="selection-indicator">
                            <Check className="w-5 h-5" />
                          </div>
                        </div>
                      ))}

                  {activeVehicleTab === "departure" && 
                    apiData.filteredVehicles
                      .filter(v => v.Type_of_Service?.toLowerCase().includes("departure"))
                      .map(vehicle => (
                        <div
                          key={vehicle.ID}
                          className={`vehicle-card ${selectedVehicles.departure?.ID === vehicle.ID ? "selected" : ""}`}
                          onClick={() => handleVehicleSelect(vehicle, "departure")}
                        >
                          <div className="vehicle-image">
                            {getVehicleImageUrl(vehicle) ? (
                              <img
                                src={getVehicleImageUrl(vehicle)}
                                alt={vehicle.Type_of_Vehicle}
                                onError={(e) => {
                                  // Hide image if it fails to load
                                  e.target.style.display = 'none';
                                }}
                              />
                            ) : (
                              <div className="no-image-placeholder">
                                <Car className="w-12 h-12 text-gray-400" />
                                <span className="text-sm text-gray-500">No Image</span>
                              </div>
                            )}
                          </div>
                          <div className="vehicle-info">
                            <h4>{vehicle.Type_of_Vehicle}</h4>
                            <div className="vehicle-price">${vehicle.Price_Per_Vehicle}</div>
                            <div className="vehicle-capacity">
                              <Users className="w-4 h-4" />
                              {vehicle.Minimum_Capacity} - {vehicle.Maximum_Capacity} passengers
                            </div>
                            <div className="vehicle-service">{vehicle.Type_of_Service}</div>
                          </div>
                          <div className="selection-indicator">
                            <Check className="w-5 h-5" />
                          </div>
                        </div>
                      ))}
                </div>
              </>
            ) : (
              <>
                <div className="vehicle-section-title">
                  <h3>{formData.oneWayType === "arrival" ? "Arrival Vehicles" : "Departure Vehicles"}</h3>
                </div>
                <div className="vehicles-grid">
                  {apiData.filteredVehicles
                    .filter(v => v.Type_of_Service?.toLowerCase().includes(formData.oneWayType))
                    .map(vehicle => (
                      <div
                        key={vehicle.ID}
                        className={`vehicle-card ${selectedVehicles.oneWay?.ID === vehicle.ID ? "selected" : ""}`}
                        onClick={() => handleVehicleSelect(vehicle, "oneWay")}
                      >
                        <div className="vehicle-image">
                          {getVehicleImageUrl(vehicle) ? (
                            <img
                              src={getVehicleImageUrl(vehicle)}
                              alt={vehicle.Type_of_Vehicle}
                              onError={(e) => {
                                // Hide image if it fails to load
                                e.target.style.display = 'none';
                              }}
                            />
                          ) : (
                            <div className="no-image-placeholder">
                              <Car className="w-12 h-12 text-gray-400" />
                              <span className="text-sm text-gray-500">No Image</span>
                            </div>
                          )}
                        </div>
                        <div className="vehicle-info">
                          <h4>{vehicle.Type_of_Vehicle}</h4>
                          <div className="vehicle-price">${vehicle.Price_Per_Vehicle}</div>
                          <div className="vehicle-capacity">
                            <Users className="w-4 h-4" />
                            {vehicle.Minimum_Capacity} - {vehicle.Maximum_Capacity} passengers
                          </div>
                          <div className="vehicle-service">{vehicle.Type_of_Service}</div>
                        </div>
                        <div className="selection-indicator">
                          <Check className="w-5 h-5" />
                        </div>
                      </div>
                    ))}
                </div>
              </>
            )}
          </div>
        );

      case 4:
        return (
          <div className="step-content-wrapper">
            <div className="step-header">
              <User className="step-icon" />
              <div>
                <h2>Lead Passenger Information</h2>
                <p>Primary contact details for this booking</p>
              </div>
            </div>
            
            <div className="form-grid">
              <div className="form-group">
                <label className="form-label">First Name *</label>
                <input
                  type="text"
                  name="firstName"
                  className="form-input"
                  placeholder="John"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  required
                />
              </div>
              
              <div className="form-group">
                <label className="form-label">Last Name *</label>
                <input
                  type="text"
                  name="lastName"
                  className="form-input"
                  placeholder="Doe"
                  value={formData.lastName}
                  onChange={handleInputChange}
                  required
                />
              </div>
              
              <div className="form-group">
                <label className="form-label">Phone *</label>
                <input
                  type="tel"
                  name="phone"
                  className="form-input"
                  placeholder="(123) 456-7890"
                  value={formData.phone}
                  onChange={handleInputChange}
                  required
                />
              </div>
              
              <div className="form-group">
                <label className="form-label">Email *</label>
                <input
                  type="email"
                  name="email"
                  className="form-input"
                  placeholder="john.doe@example.com"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
              </div>
              
              <div className="form-group">
                <label className="form-label">Zip Code</label>
                <input
                  type="text"
                  name="zipCode"
                  className="form-input"
                  placeholder="12345"
                  value={formData.zipCode}
                  onChange={handleInputChange}
                />
              </div>
            </div>
          </div>
        );

      case 5:
        return (
          <div className="step-content-wrapper">
            <div className="step-header">
              <CreditCard className="step-icon" />
              <div>
                <h2>Review & Payment</h2>
                <p>Confirm your booking details</p>
              </div>
            </div>

            <div className="booking-summary">
              <div className="summary-section">
                <h3>Trip Details</h3>
                <div className="summary-grid">
                  <div className="summary-item">
                    <span className="label">Passengers:</span>
                    <span className="value">{formData.adults} Adults, {formData.children} Children</span>
                  </div>
                  <div className="summary-item">
                    <span className="label">Destination:</span>
                    <span className="value">{apiData.destinations.find(d => d.ID === formData.destination)?.Destination}</span>
                  </div>
                  <div className="summary-item">
                    <span className="label">Hotel:</span>
                    <span className="value">
                      {apiData.hotels.find(h => h.ID === formData.hotel)?.Hotel}
                      {formData.selectedZone && ` (${formData.selectedZone})`}
                    </span>
                  </div>
                  <div className="summary-item">
                    <span className="label">Airport:</span>
                    <span className="value">{apiData.airports.find(a => a.ID === formData.airport)?.Airport}</span>
                  </div>
                </div>
              </div>

              <div className="summary-section">
                <h3>Flight Information</h3>
                <div className="flight-summary">
                  <div className="flight-type-badge">
                    {formData.flightType === 'round' ? 'Round Trip' : 'One Way'}
                  </div>

                  {/* {formData.flightType === 'round' ? (
                    <>
                      {formData.arrivalDate && (
                        <div className="flight-item">
                          <Plane className="w-4 h-4" style={{ transform: 'rotate(-45deg)' }} />
                          <span>
                            Arrival: {formData.arrivalDate.toLocaleDateString()} - 
                            {apiData.airlines.find(a => a.ID === formData.arrivalAirline)?.Airline || formData.arrivalAirline}
                            {formData.arrivalFlightNumber && ` - Flight: ${formData.arrivalFlightNumber}`}
                            {formData.arrivalManualFlight && ` - Flight: ${formData.arrivalManualFlight}`}
                          </span>
                        </div>
                      )}
                      {formData.departureDate && (
                        <div className="flight-item">
                          <Plane className="w-4 h-4" style={{ transform: 'rotate(135deg)' }} />
                          <span>
                            Departure: {formData.departureDate.toLocaleDateString()} - 
                            {apiData.airlines.find(a => a.ID === formData.departureAirline)?.Airline}
                            {formData.departureFlightNumber && ` - Flight: ${formData.departureFlightNumber}`}
                            {formData.departureManualFlight && ` - Flight: ${formData.departureManualFlight}`}
                          </span>
                        </div>
                      )}
                    </>
                  ) : (
                    formData.oneWayDate && (
                      <div className="flight-item">
                        <Plane className="w-4 h-4" style={{ transform: formData.oneWayType === 'departure' ? 'rotate(135deg)' : 'rotate(-45deg)' }} />
                        <span>
                          {formData.oneWayType}: {formData.oneWayDate.toLocaleDateString()} - 
                          {apiData.airlines.find(a => a.ID === formData.oneWayAirline)?.Airline}
                          {formData.oneWayFlightNumber && ` - Flight: ${formData.oneWayFlightNumber}`}
                          {formData.oneWayManualFlight && ` - Flight: ${formData.oneWayManualFlight}`}
                        </span>
                      </div>
                    )
                  )} */}

{formData.flightType === 'round' ? (
  <>
    {formData.arrivalDate && (
      <div className="flight-item">
        <Plane className="w-4 h-4" style={{ transform: 'rotate(-45deg)' }} />
        <span>
          Arrival: {formData.arrivalDate.toLocaleDateString()} - 
          {apiData.airlines.find(a => a.ID === formData.arrivalAirline)?.Airline || formData.arrivalAirline}
          {formData.arrivalFlightNumber && ` - Flight: ${flights.arrival.find(f => f.id === formData.arrivalFlightNumber)?.flightCode || formData.arrivalFlightNumber}`}
          {formData.arrivalManualFlight && ` - Flight: ${formData.arrivalManualFlight}`}
        </span>
      </div>
    )}
    {formData.departureDate && (
      <div className="flight-item">
        <Plane className="w-4 h-4" style={{ transform: 'rotate(135deg)' }} />
        <span>
          Departure: {formData.departureDate.toLocaleDateString()} - 
          {apiData.airlines.find(a => a.ID === formData.departureAirline)?.Airline}
          {formData.departureFlightNumber && ` - Flight: ${flights.departure.find(f => f.id === formData.departureFlightNumber)?.flightCode || formData.departureFlightNumber}`}
          {formData.departureManualFlight && ` - Flight: ${formData.departureManualFlight}`}
        </span>
      </div>
    )}
  </>
) : (
  formData.oneWayDate && (
    <div className="flight-item">
      <Plane className="w-4 h-4" style={{ transform: formData.oneWayType === 'departure' ? 'rotate(135deg)' : 'rotate(-45deg)' }} />
      <span>
        {formData.oneWayType}: {formData.oneWayDate.toLocaleDateString()} - 
        {apiData.airlines.find(a => a.ID === formData.oneWayAirline)?.Airline}
        {formData.oneWayFlightNumber && ` - Flight: ${flights.oneWay.find(f => f.id === formData.oneWayFlightNumber)?.flightCode || formData.oneWayFlightNumber}`}
        {formData.oneWayManualFlight && ` - Flight: ${formData.oneWayManualFlight}`}
      </span>
    </div>
  )
)}

                </div>
              </div>

              <div className="summary-section">
                <h3>Selected Vehicles</h3>
                <div className="vehicle-summary">
                  {formData.flightType === 'round' ? (
                    <>
                      {selectedVehicles.arrival && (
                        <div className="vehicle-summary-item">
                          <div className="vehicle-summary-info">
                            <h4>Arrival Vehicle</h4>
                            <p>{selectedVehicles.arrival.Type_of_Vehicle}</p>
                          </div>
                          <div className="vehicle-summary-price">
                            ${selectedVehicles.arrival.Price_Per_Vehicle}
                          </div>
                        </div>
                      )}
                      {selectedVehicles.departure && (
                        <div className="vehicle-summary-item">
                          <div className="vehicle-summary-info">
                            <h4>Departure Vehicle</h4>
                            <p>{selectedVehicles.departure.Type_of_Vehicle}</p>
                          </div>
                          <div className="vehicle-summary-price">
                            ${selectedVehicles.departure.Price_Per_Vehicle}
                          </div>
                        </div>
                      )}
                    </>
                  ) : (
                    selectedVehicles.oneWay && (
                      <div className="vehicle-summary-item">
                        <div className="vehicle-summary-info">
                          <h4>{formData.oneWayType} Vehicle</h4>
                          <p>{selectedVehicles.oneWay.Type_of_Vehicle}</p>
                        </div>
                        <div className="vehicle-summary-price">
                          ${selectedVehicles.oneWay.Price_Per_Vehicle}
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>

              <div className="summary-section">
                <h3>Contact Information</h3>
                <div className="summary-grid">
                  <div className="summary-item">
                    <span className="label">Name:</span>
                    <span className="value">{formData.firstName} {formData.lastName}</span>
                  </div>
                  <div className="summary-item">
                    <span className="label">Phone:</span>
                    <span className="value">{formData.phone}</span>
                  </div>
                  <div className="summary-item">
                    <span className="label">Email:</span>
                    <span className="value">{formData.email}</span>
                  </div>
                  {formData.zipCode && (
                    <div className="summary-item">
                      <span className="label">Zip Code:</span>
                      <span className="value">{formData.zipCode}</span>
                    </div>
                  )}
                </div>
              </div>

              <div className="total-section">
                <div className="total-amount">
                  <span>Total Amount</span>
                  <span className="total-price">${formData.total}</span>
                </div>
              </div>

              {showFlywirePayment && (
                <div className="flywire-payment-section">
                  <h3>Complete Payment</h3>
                  <FlywirePayment
                    frontendKey="fk_c3RRZm82dWxIODhrY0JybzVuNzNpUT09"
                    sessionId={flywireSessionId}
                    customerData={{
                      firstName: formData.firstName,
                      lastName: formData.lastName,
                      email: formData.email,
                      phone: formData.phone,
                      zipCode: formData.zipCode
                    }}
                    onSuccess={handleFlywireSuccess}
                    onError={handleFlywireError}
                    appearance={{
                      variables: { primaryColor: "#5a81f0" }
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="booking-container">
      {/* Header */}
      <div className="booking-header">
        <div className="header-content">
          <img src={headerImg} alt="header-image" width="60%" height="60%" />
          <h1 className="main-title">Book Your Trip</h1>
          <p className="main-subtitle">Easy, fast, and reliable transportation booking</p>
        </div>
      </div>

      {/* Progress Bar */}
      <ProgressBar />

      {/* Toast Notifications */}
      {error && (
        <NotificationToast 
          message={error} 
          type="error" 
          onClose={() => setError('')} 
        />
      )}
      
      {success && (
        <NotificationToast 
          message={success} 
          type="success" 
          onClose={() => setSuccess('')} 
        />
      )}

      {/* Main Content */}
      <div className="booking-content">
        <form onKeyDown={handleKeyDown}>
          <div className="step-container">
            {renderStepContent()}
          </div>

          {/* Navigation */}
          <div className="step-navigation">
            {currentStep > 1 && (
              <button
                type="button"
                className="nav-btn nav-btn-secondary"
                onClick={prevStep}
              >
                <ChevronLeft className="w-4 h-4" />
                Previous
              </button>
            )}

            <div className="nav-spacer" />
            
              {currentStep < 5 ? (
                <button
                  type="button"
                  className="nav-btn nav-btn-primary"
                  onClick={nextStep}
                  disabled={isLoading.destinations}
                >
                  Next
                  <ChevronRight className="w-4 h-4" />
                </button>
              ) : (
                !showFlywirePayment && (
                  <button
                    type="button"
                    className="nav-btn nav-btn-success"
                    onClick={() => {
                      handleSubmit();
                    }}
                    disabled={
                      isLoading.destinations ||
                      isSubmitting ||
                      (formData.flightType === "round"
                        ? !selectedVehicles.arrival || !selectedVehicles.departure
                        : !selectedVehicles.oneWay)
                    }
                  >
                    {isSubmitting ? (
                      <>
                        <Loader2 className="w-4 h-4 animate-spin" />
                        Processing...
                      </>
                    ) : (
                      <>
                        Complete Booking
                        <CreditCard className="w-4 h-4" />
                      </>
                    )}
                  </button>
                )
              )}

          </div>
        </form>
      </div>

      </div>
  )

}
      

export default TripBookingForm;